import React from 'react';
import { motion } from 'framer-motion';
import { MOCK_PAYROLL_PROVIDERS } from '../../utils/mockData';
import { CheckCircle, ArrowRight } from 'lucide-react';
interface PayrollProviderListProps {
  onSelect: (providerId: string) => void;
  selectedId?: string;
}
export function PayrollProviderList({
  onSelect,
  selectedId
}: PayrollProviderListProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2042">
      {MOCK_PAYROLL_PROVIDERS.map((provider, index) => <motion.button key={provider.id} onClick={() => onSelect(provider.id)} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.1
    }} className={`relative p-4 rounded-xl border-2 text-left transition-all group ${selectedId === provider.id ? 'border-blue-600 bg-blue-50 ring-2 ring-blue-200 ring-offset-2' : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'}`} data-id="element-2043">
          {selectedId === provider.id && <div className="absolute top-3 right-3 text-blue-600" data-id="element-2044">
              <CheckCircle className="h-5 w-5" data-id="element-2045" />
            </div>}

          <div className="flex items-center mb-3" data-id="element-2046">
            <div className="h-10 w-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center p-1 mr-3" data-id="element-2047">
              <span className="text-xs font-bold text-gray-700" data-id="element-2048">
                {provider.name.substring(0, 2).toUpperCase()}
              </span>
            </div>
            <h4 className="font-semibold text-gray-900" data-id="element-2049">{provider.name}</h4>
          </div>

          <p className="text-xs text-gray-500 mb-3 line-clamp-2" data-id="element-2050">
            {provider.description}
          </p>

          <div className="flex items-center text-xs font-medium text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2051">
            Connect <ArrowRight className="h-3 w-3 ml-1" data-id="element-2052" />
          </div>
        </motion.button>)}
    </div>;
}